export const COMPANY_REVIEW_TYPES = {
  COMPANY_AWARDS: 'COMPANY_AWARDS',
  COMPANY_RATINGS: 'COMPANY_RATINGS',
};
